module.exports = __webpack_public_path__ + "img/naverwebtoon_bigbanner.a9abe654.png";